/**
 * @fileoverview Syndicator Showdown — Shareable Result card
 * @module components/share/ShareResultCard
 *
 * Presentational card for sharing a race result (winner / top-5 placing) or
 * an overall leaderboard rank. Rendered over the matching premium dark
 * artwork (top1-dark.png / top5-dark.png / stable-share-dark.png — see
 * utils/shareArtwork.js), used as the `previewComponent` inside the shared
 * ShareQrModal / ShareResultModal.
 */

import React from 'react';
import { getShareArtwork } from '../../utils/shareArtwork';
import './ShareResultCard.css';

export default function ShareResultCard({
  artworkType = 'winner',
  eyebrow,
  title,
  body,
  statLabel,
  statValue,
  compact = false,
}) {
  return (
    <div
      className={`src-card ${compact ? 'src-card--compact' : ''}`}
      style={{ backgroundImage: `url(${getShareArtwork(artworkType)})` }}
    >
      <div className="src-overlay" />
      <div className="src-content">
        {eyebrow && <span className="src-eyebrow">{eyebrow}</span>}
        {title && <h3 className="src-title">{title}</h3>}
        {body && <p className="src-body">{body}</p>}
        {statValue != null && (
          <div className="src-stat">
            <span className="src-stat-val">{statValue}</span>
            {statLabel && <span className="src-stat-label">{statLabel}</span>}
          </div>
        )}
      </div>
    </div>
  );
}
